import type { AxiosResponse } from 'axios';

import type { ResponseWithPagination } from '@/utils/types';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type {
  DeviceBody, DeviceCreateBody, DeviceUpdateBody, IDevice,
} from '../devices/types';
import type { IRequestBodyFilter, StaticDevicesFilters } from './types';

export const create = (data: DeviceCreateBody)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.DEVICES}/new`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getAll = (data: Partial<DeviceBody>)
  : Promise<void | AxiosResponse<ResponseWithPagination<IDevice>>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV_DEVICES}/select`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const getIds = (): Promise<void | AxiosResponse<string []>> => axiosInstance({
  url: `${ROUTES.DEVICES}/ids`,
  method: 'GET',
  headers: {
    authorization: true,
  },
});

export const getFilters = (
  data: IRequestBodyFilter,
): Promise<void | AxiosResponse<StaticDevicesFilters>> => axiosInstance({
  url: `${ROUTES.STATIC_ADV_DEVICES}/select/filters`,
  method: 'POST',
  headers: {
    authorization: true,
  },
  data,
});

export const update = (id: string, data: DeviceUpdateBody)
  : Promise<void | AxiosResponse<{ result: 0 }>> => axiosInstance({
  url: `${ROUTES.DEVICES}/${id}`,
  method: 'PATCH',
  headers: {
    authorization: true,
  },
  data,
});
